export const IMPERSONATED_KEY = 'impersonated';
export const APP_ACTIVE_CONTEXT_KEY = 'app_active_context';
export const ACCESS_TOKEN_KEY = 'access_token';
// Track where `ACCESS_TOKEN_KEY` came from so we can handle invalid-link UX
// without breaking normal sessions that also store an access token (e.g. sites API).
export const ACCESS_TOKEN_SOURCE_KEY = 'access_token_source';
export const MCP_OAUTH_AUTHORIZATION_URL_KEY = 'mcp_oauth_authorization_url';
export const MCP_OAUTH_STARTED_AT_MS_KEY = 'mcp_oauth_started_at_ms';
export const REFERRER_STORAGE_KEY = 'login-referrer';
export const PENDING_VISITS_REVIEWED = 'PENDING_VISITS_REVIEWED';
export const CAPEX_BANNER = 'capex-banner';
export const DAILY_MENU_OPENED_CARDS = 'daily_menu_opened_cards';
export const TEST_KEY = 'test_key';
export const SHOW_INHERITED_VENDOR_WELCOME_MODAL = 'showInheritedVendorWelcomeModal';
export const HIDE_VERIFIED_VENDOR_SELECTED_DIALOG = 'hideVerifiedVendorSelectedDialog';
export const WORK_ORDER_SUBMITTED_USING_VERIFIED = 'workOrderSubmittedUsingVerified';
export const REQUEST_AUTOPAY_SETTINGS = 'requestAutopaySettings';
export const AUTOBOTS_VENDOR_CREATE_JOB_FEATURE_HIGHLIGHT = 'vendorCreateJobFeatureHighlight';
export const APP_INVOICE_LEVEL_FASTPAY_FAKEDOOR = 'appInvoiceLevelFastPayFakedoor';
export const PMC_CHATBOT_SESSION_ID = 'pmcChatbotSessionId';
export const IYOF_CHATBOT_SESSION_ID = 'iyofChatbotSessionId';
export const OFF_RESQ_CHATBOT_SESSION_ID = 'offResqChatbotSessionId';
